import { NextSeo } from 'next-seo';
import * as React from 'react';

import { Video } from '@/lib/videos';

import FAQSection from '@/components/landing/FAQSection';
import FeaturesSection, { Feature } from '@/components/landing/FeaturesSection';
import GetStartedSection from '@/components/landing/GetStartedSection';
import HeroSection from '@/components/landing/HeroSection';
import TestimonialsSection from '@/components/landing/TestimonialsSection';
import Layout from '@/components/layout/Layout';

const ForAgenciesPage: React.FC<{ videos: Video[] }> = ({ videos }) => {
  const title = `Turn podcasts into viral clips (in seconds)`;
  return (
    <>
      <NextSeo title={title} />
      <Layout mode='light'>
        <main>
          <HeroSection
            pageType='For Agencies'
            titleTop="Automate your team's editing workflow"
            titleBottom=''
            subtitle='We use AI to automatically find the best moments of your videos and give you ready-to-post clips within minutes.'
          />
          {/*<DemoVideoSection />*/}
          <FeaturesSection>
            <Feature
              name='Keep the team small'
              description='Grow your client base without needing to hire more employees to keep up.'
              image='/images/higher-fewer.png'
              alt='Hero image'
            />
            <Feature
              name='Quicker turnaround'
              description='Impress your clients by delivering clips to them much faster.'
              image='/images/faster-turnaround.png'
              alt='Hero image'
              flipped
            />
            <Feature
              name='Increase your output'
              description='Seamlessly take on more clients without increasing your workload.'
              image='/images/increase-output.png'
              alt='Hero image'
            />
            <Feature
              name='Cut production costs'
              description='Pay less than 10x the price of what it costs to hire an editor.'
              image='/images/lower-price-4.png'
              alt='Hero image'
              flipped
            />
          </FeaturesSection>
          <TestimonialsSection />
          <FAQSection />
          <GetStartedSection />
        </main>
      </Layout>
    </>
  );
};

export default ForAgenciesPage;
